// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonProbe_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1924 0.560059L15.435 4.8027L11.8995 6.92402L11.1924 6.21691L4.51566 12.3595C4.40364 12.1876 4.2722 12.0246 4.12132 11.8738C3.97044 11.7229 3.8075 11.5914 3.63558 11.4794L9.77817 4.8027L9.07107 4.09559L11.1924 0.560059ZM0.585787 15.4093C1.36684 16.1903 2.63316 16.1903 3.41421 15.4093C4.19526 14.6283 4.19526 13.3619 3.41421 12.5809C2.63317 11.7998 1.36684 11.7998 0.585787 12.5809C-0.195262 13.3619 -0.195262 14.6283 0.585787 15.4093Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonProbe is a generated icon component.
 */
let IconCommonProbe = IconCommonProbe_1 = class IconCommonProbe extends IconBaseElement {
    render() {
        return html `${IconCommonProbe_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonProbe.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonProbe = IconCommonProbe_1 = __decorate([
    customElement('zui-icon-common-probe')
], IconCommonProbe);
export { IconCommonProbe };
